import {isBrowser} from '@/utils';

const TOKEN_NAME = '_facturando_token';
const USER_NAME = '_facturando_user';
const DECIMALS = '_facturando_decimals';
const LANGUAGE = '_facturando_lng';
const REGISTER_STATUS = '_facturando_register';

export const saveToken = (token?: string): void => (isBrowser && token ? localStorage.setItem(TOKEN_NAME, token) : null);
export const getToken = (): string => (isBrowser ? localStorage.getItem(TOKEN_NAME) : null);
export const removeToken = (): void => (isBrowser ? localStorage.removeItem(TOKEN_NAME) : null);

export const saveUser = (user?: object): void => (isBrowser && user ? localStorage.setItem(USER_NAME, JSON.stringify(user)) : null);
export const getUser = (): object => (isBrowser ? JSON.parse(localStorage.getItem(USER_NAME)) : null);
export const removeUser = (): void => (isBrowser ? localStorage.removeItem(USER_NAME) : null);
export const getUserScopes = (): Array<string> => (isBrowser ? JSON.parse(localStorage.getItem(USER_NAME))?.scopes || null : null);

export const getDecimals = (): number => (isBrowser ? parseInt(localStorage.getItem(DECIMALS)) : null);
export const saveDecimals = (decimals?: number): void => (isBrowser && decimals ? localStorage.setItem(DECIMALS, `${decimals}`) : null);
export const removeDecimals = (): void => (isBrowser ? localStorage.removeItem(DECIMALS) : null);

export const getLanguage = (): string => (isBrowser ? localStorage.getItem(LANGUAGE) : "es");

const register_complete = "true";
export const saveRegisterStatus = (status?: boolean): void => (isBrowser && status ? localStorage.setItem(REGISTER_STATUS, `${status}`) : null);
export const getRegisterStatus = (): boolean => (isBrowser ? (localStorage.getItem(REGISTER_STATUS) === register_complete) : false);
export const removeRegisterStatus = (): void => (isBrowser ? localStorage.removeItem(REGISTER_STATUS) : null);